// import React from 'react';
import queryString from 'query-string'
import { optionsDict, OptionId } from '../data/options'
import { questions_list } from '../data/questions'
import {
  CategoryFeatureDictType,
  CategoryFeature,
  CATEGORY_FEATURES,
  Category,
  CATEGORIES,
  CategoryToCategoryFeatureDictType,
  CategoryToFeatureDictType,
  FeatureDictType,
  Feature,
  // Category2CategoryFeature,
  // Category2NameType,
  // Category1CategoryFeature,
  // Category1NameType,
  // CATEGORY_1_FEATURES,
  // CATEGORY_1_NAMES,
  // CATEGORY_2_FEATURES,
  // CATEGORY_2_NAMES,
  // CATEGORY_3_FEATURES,
  // CATEGORY_3_NAMES,
  // CATEGORY_4_FEATURES,
  // CATEGORY_4_NAMES,
  // Category3NameType,
  // Category3CategoryFeature,
  // Category4NameType,
  // Category4CategoryFeature,
} from '../data/features'
import { AnswerType, QuizResults } from '../contexts/quizContext'

export const getFeatureOnly = (feature: CategoryFeature): string =>
  feature.split('>')[1] as string
export const getCategoryOnly = (feature: CategoryFeature): Category =>
  feature.split('>')[0] as Category

// prefers later items (good for realism order)
const getKeyWithMaxValue = (obj: FeatureDictType): Feature =>
  Object.keys(obj).reduce(
    (a, b) => ((obj[a as Feature] || 0) > (obj[b as Feature] || 0) ? a : b),
    '' as Feature,
  )

/**
 * Get the features dict for a particular category
 * @param obj
 * @param category
 * @returns
 */
const getIndividualCategory = (
  obj: CategoryFeatureDictType,
  category: Category,
): FeatureDictType =>
  Object.keys(obj)
    .filter((k) => k.includes(category))
    .reduce(
      (accu, key) => ({
        ...accu,
        [key.split('>')[1]]: obj[key],
      }),
      {},
    )

const removeCategories = (
  obj: CategoryFeatureDictType,
  categories: Array<Category>,
): CategoryFeatureDictType =>
  Object.keys(obj)
    .filter((k) => !categories.includes(getCategoryOnly(k as CategoryFeature)))
    .reduce(
      (a, k) => ({
        ...a,
        [k]: obj[k as CategoryFeature],
      }),
      {},
    )

export const getStyleFromQuery = (query: string): Partial<QuizResults> => {
  throw new Error()
  // let results: Partial<QuizResults> = {} // make a copy
  // const query_dict = queryString.parse(query.toLowerCase())
  // // get realism from query_dict only if it fits the type
  // let realism = query_dict.realism as Category2NameType
  // if (CATEGORY_2_NAMES.includes(realism)) {
  //   results[
  //     'hosting_style'
  //   ] = `hosting_style>${realism}` as Category2CategoryFeature
  // } else if (
  //   [...Array(CATEGORY_2_FEATURES.length).keys()].includes(parseInt(realism))
  // ) {
  //   results['hosting_style'] = CATEGORY_2_FEATURES[
  //     parseInt(realism)
  //   ] as Category2CategoryFeature
  // }

  // let podcast_genre = query_dict.podcast_genre as Category1NameType
  // if (CATEGORY_1_NAMES.includes(podcast_genre)) {
  //   results[
  //     'podcastGenre'
  //   ] = `podcast_genre>${podcast_genre}` as Category1CategoryFeature
  // } else if (
  //   [...Array(CATEGORY_1_FEATURES.length).keys()].includes(
  //     parseInt(podcast_genre),
  //   )
  // ) {
  //   results['podcastGenre'] = CATEGORY_1_FEATURES[
  //     parseInt(podcast_genre)
  //   ] as Category1CategoryFeature
  // }

  // let first_feature = query_dict.first_feature as Category3NameType
  // if (CATEGORY_3_NAMES.includes(first_feature)) {
  //   results['firstFeature'] = first_feature as Category3CategoryFeature
  // } else if (
  //   [...Array(CATEGORY_3_FEATURES.length).keys()].includes(
  //     parseInt(first_feature),
  //   )
  // ) {
  //   results['firstFeature'] = CATEGORY_3_FEATURES[
  //     parseInt(first_feature)
  //   ] as Category3CategoryFeature
  // }

  // let second_feature = query_dict.second_feature as Category4NameType
  // if (CATEGORY_4_NAMES.includes(second_feature)) {
  //   results['secondFeature'] = second_feature as Category4CategoryFeature
  // } else if (
  //   [...Array(CATEGORY_4_FEATURES.length).keys()].includes(
  //     parseInt(second_feature),
  //   )
  // ) {
  //   results['secondFeature'] = CATEGORY_4_FEATURES[
  //     parseInt(second_feature)
  //   ] as Category4CategoryFeature
  // }

  // return results
}

export const capitalize = (word: string): string => {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export const capitalizeSentence = (sentence: string): string => {
  return sentence
    .split(' ')
    .map((s) => capitalize(s))
    .join(' ')
}

export const convertFeatureToTitle = (feature: CategoryFeature): string => {
  return capitalizeSentence(
    feature.replace(/>/g, ': ').replace(/_/g, ' ').replace('-d', 'D'),
  )
}

/**
 * find the max feature for each category
 * @param artStyleData
 * @returns
 */
export const getStyle = (
  artStyleData: CategoryFeatureDictType,
): QuizResults => {
  // const featuresOnly = removeCategories(artStyleData, [
  //   'hosting_style',
  //   'podcast_genre',
  // ])
  // console.log(`getStyle artStyleData: ${JSON.stringify(artStyleData)}`)

  const categorizedFeatures: CategoryToFeatureDictType = CATEGORIES.reduce(
    (accu, category) => ({
      ...accu,
      [category]: getIndividualCategory(artStyleData, category),
    }),
    {},
  ) as CategoryToCategoryFeatureDictType
  console.log(`getStyle categorizedFeatures:`, categorizedFeatures)

  const isFiction =
    getKeyWithMaxValue(categorizedFeatures['fiction_nonfiction']) === 'fiction'

  const results = CATEGORIES.reduce((accu, category) => {
    const fictionAwareCategorizedFeatures = Object.fromEntries(
      Object.entries(categorizedFeatures[category]).filter(([key]) =>
        isFiction ? !key.includes('_nonfiction') : !key.includes('_fiction'),
      ),
    )
    return {
      ...accu,
      [category]: getKeyWithMaxValue(fictionAwareCategorizedFeatures),
    }
  }, {} as QuizResults)

  // const results = {
  //   podcastGenre,
  //   hostingStyle,
  //   publishingSchedule,
  //   podcastTone,
  // }
  // console.log(`getStyle results: ${JSON.stringify(results)}`)

  // results['hosting_style'] = 'collaborative_nonfiction'
  return results
}

/**
 * Get the relative strength of each feature in an object
 * Set value to zero if fiction or nonfiction and that isn't set
 * @param answers
 * @returns
 */
export const getStyleData = (
  answers: Array<AnswerType>,
): CategoryFeatureDictType => {
  // console.log('getStyleData', answers)
  const EMPTY_STYLE_VALUES = CATEGORY_FEATURES.reduce(
    (accu, category) => ({ ...accu, [category]: 0 }),
    {},
  )

  var style_values = { ...EMPTY_STYLE_VALUES } // make copy

  for (var q = 0; q < questions_list.length; q++) {
    let answer = answers[q] ?? {}

    style_values = Object.keys(answer).reduce((accu, key) => {
      if (answer[key] === true) {
        // if answer is marked as true
        if (optionsDict[key] === undefined) {
          throw new Error(`optionsDict is undefined for key: ${key}, ${answer}`)
        }
        // Use this filter to remove nonfiction items if the first question has been answered fiction
        return addObjects(accu, optionsDict[key]!.features) // add values from the categories
      }
      return accu //
    }, style_values)
  }

  /// TESTING TO FIND WHICH question option doesn't exist in the artwork, or which doesn't have a category
  // for (var q = 0; q < questions_list.length; q++) {
  //     let answer = answers[q];

  //     style_values = Object.keys(answer).reduce( (accu, key) => {
  //         if (answer[key] === true){ // if answer is marked as true
  //             return addObjects(accu, artwork[key]['categories']) // add values from the categories
  //         }
  //         return accu //
  //     }, style_values )
  // }

  // return style_values

  /**
   * Get value for each option assuming all possible answers are chosen
   * TODO: Need to handle negatives (by ignoring them?)
   */
  const max_categories = questions_list.reduce((accu, question) => {
    return addObjects(
      accu,
      question['options'].reduce((o_accu, key) => {
        if (optionsDict[key] === undefined) {
          throw new Error(`optionsDict is undefined for key: ${key}`)
        }
        return addObjects(
          o_accu,
          optionsDict[key]!.features,
          1, //default values
        )
      }, {}),
    )
  }, EMPTY_STYLE_VALUES)

  const style_proportions = divideObjects(style_values, max_categories)
  // console.log('Style values: ' + JSON.stringify(style_values))
  // console.log('Max_categories: ' + JSON.stringify(max_categories))
  // console.log('Style proportions data: ' + JSON.stringify(style_proportions))

  return style_proportions
}

export type numericalObject = {
  [key: string]: number | undefined
}

export const addObjects = (
  obj1: numericalObject,
  obj2: numericalObject,
  default_value = 0,
) => {
  const keys = [...new Set([...Object.keys(obj1), ...Object.keys(obj2)])]
  return keys.reduce((accu, key) => {
    const obj1_value = obj1.hasOwnProperty(key)
      ? parseInt(String(obj1[key]))
      : default_value
    const obj2_value = obj2.hasOwnProperty(key)
      ? parseInt(String(obj2[key]))
      : default_value
    return {
      ...accu,
      [key]: obj1_value + obj2_value,
    }
  }, {})
}

/**
 * key-wise division of objects
 * @param numerator object of numerators
 * @param denominator object of denominators
 * @returns
 */
export const divideObjects = (
  numerator: numericalObject,
  denominator: numericalObject,
): { [key: string]: number } => {
  //Create a new object of the values of obj1 divided by obj2
  const keys = [
    ...new Set([...Object.keys(numerator), ...Object.keys(denominator)]),
  ]
  return keys.reduce((accu, key) => {
    const numerator_value = numerator.hasOwnProperty(key)
      ? parseInt(String(numerator[key]))
      : 0
    const denominator_value = denominator.hasOwnProperty(key)
      ? parseInt(String(denominator[key]))
      : Math.max(numerator_value, 1)
    return {
      ...accu,
      [key]: numerator_value / denominator_value,
    }
  }, {} as { [key: string]: number })
}

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
export const numberToLetter = (number: number) => {
  var charIndex = number % alphabet.length // get the letter
  var quotient = number / alphabet.length
  var additionalLetters = ''
  if (charIndex === 0) {
    charIndex = alphabet.length
    quotient--
  }
  if (quotient >= 1) {
    additionalLetters = numberToLetter(parseInt(String(quotient)))
  }
  return additionalLetters + alphabet.charAt(charIndex - 1)
}
//numberToLetter(735) == 'ABG'

export const shuffleArray = <T extends unknown>(array: Array<T>): Array<T> => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

export const toTitleCase = (str: string) =>
  str
    .split(' ')
    .map((s) => s[0].toUpperCase() + s.slice(1).toLowerCase())
    .join(' ')

export const divId = (str: string) => `div-id-${str}`
